import { useState, useEffect, useCallback } from 'react';

/**
 * Shared fetch hook for pharmacy tabs.
 * @param {() => Promise<any>} fetcher
 * @param {any[]} deps
 */
export default function usePharmacyLoad(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetcher();
      setData(result);
    } catch (e) {
      setError(e?.message || 'Failed to load data');
      setData(null);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load, setData };
}
